import { render } from "./CreateReviewFromWebsite.vue?vue&type=template&id=3dc3b91e"
import script from "./CreateReviewFromWebsite.vue?vue&type=script&lang=js"
export * from "./CreateReviewFromWebsite.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__